import { render, staticRenderFns } from "./ParcelItemDataComponent.vue?vue&type=template&id=41a16bcc&scoped=true&"
import script from "./ParcelItemDataComponent.vue?vue&type=script&lang=js&"
export * from "./ParcelItemDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParcelItemDataComponent.vue?vue&type=style&index=0&id=41a16bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a16bcc",
  null
  
)

export default component.exports